<template>
  <div></div>
</template>

<script>
import { UserManager, WebStorageStateStore } from 'oidc-client';

export default {
  name: 'ForceLogin',
  beforeMount() {
    let conf = {
      authority: process.env.VUE_APP_API_ESSILOR_PRO_AUTHORITY,
      client_id: process.env.VUE_APP_API_ESSILOR_PRO_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_API_ESSILOR_PRO_REDIRECT_URI,
      response_type: process.env.VUE_APP_API_ESSILOR_PRO_RESPONSE_TYPE,
      scope: process.env.VUE_APP_API_ESSILOR_PRO_SCOPE,
      post_logout_redirect_uri: process.env.VUE_APP_API_ESSILOR_PRO_LOGOUT_REDIRECT_URI,
    };
    conf.userStore = new WebStorageStateStore({ store: window.sessionStorage });
    let mgr = new UserManager(conf);
    window.sessionStorage.removeItem('storeId');
    mgr.signoutRedirect();
  },
};
</script>

<style scoped />
